<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="220px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="副标题" prop="subTitle">
        <el-input v-model="form.subTitle" placeholder="请输入副标题"></el-input>
      </el-form-item>
      <el-form-item label="标题图片" prop="titleImg2">
        <uploadImg v-model="form.titleImg" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="封面图" prop="cover2">
        <uploadImg v-model="form.cover" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="限制参与证书" prop="certIds">
        <el-select class="filter-item" multiple v-model="form.certIds" placeholder="请选择限制参与证书">
          <el-option v-for="item in certIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联任务" prop="clockInThemeIds">
        <el-select class="filter-item" filterable  multiple v-model="form.clockInThemeIds" placeholder="请选择任务">
          <el-option v-for="item in themeData" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker v-model="form.startTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="开奖时间" prop="lotteryType">
        <el-radio-group v-model="form.lotteryType">
          <el-radio :label="0">指定时间</el-radio>
          <el-radio :label="1">全部完成</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开奖时间" prop="lotteryTime" v-if="form.lotteryType == 0">
        <el-date-picker v-model="form.lotteryTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="参与方式" prop="joinType">
        <el-radio-group v-model="form.joinType">
          <el-radio :label="0">直接参与</el-radio>
          <el-radio :label="1">其他途径</el-radio>
        </el-radio-group>
      </el-form-item>
      <div
        style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;"
        v-if="form.joinType == 1"
      >
        <div
          v-for="(item3,index3) in form.joinWaysList"
          :key="index3"
          style="margin: 0px auto;margin-top: 20px; width:98%;border:1px solid"
        >
          <div
            style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "
          >跳转模块</div>
          <el-form-item
            label="icon"
            required
            :prop="'joinWaysList.' + index3 + '.icon'"
            :rules="[
            { required: true, message: '请上传icon', trigger: 'change' },
            ]"
          >
            <uploadImg3
              v-model="item3.icon"
              :imgSize="1"
              :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
            ></uploadImg3>
          </el-form-item>
          <el-form-item label="跳转地址" required>
            <jumpType :Jumpurls="item3.Jumpurl"></jumpType>
          </el-form-item>
          <div style="display: flex;justify-content: center;margin-bottom:20px">
            <el-button type="primary" size="mini" @click="addjumpModal(index3)">+增加跳转模块</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="removejumpModal(index3)"
              v-if="index3 !== 0"
            >-删除跳转模块</el-button>
          </div>
        </div>
      </div>
      <el-form-item label="奖品背景" prop="giftBg2">
        <uploadImg v-model="form.giftBg2" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="经验值门槛" prop="limitGrowth">
        <el-input v-model.number="form.limitGrowth" placeholder="请输入经验值门槛"></el-input>
      </el-form-item>
      <el-form-item label="主题视频" prop="guideVideo2">
        <uploadVideo v-model="form.guideVideo2" :text="['视频大小50m以内', '视频格式mp4']"></uploadVideo>
      </el-form-item>
      <el-form-item label="内容背景(人物)" prop="contentBg2">
        <uploadImg
          v-model="form.contentBg2"
          :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>
      <el-form-item label="任务背景" prop="taskBg2">
        <uploadImg v-model="form.taskBg2" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="主题背景" prop="themeBg2">
        <uploadImg v-model="form.themeBg2" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="规则详情" prop="ruleInfo2">
        <uploadImg v-model="form.ruleInfo2" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
        <div
          style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; "
        >奖品区域</div>
        <el-collapse accordion>
          <el-collapse-item v-for="(item, index) in form.gifts" :key="index">
            <span
              slot="title"
              style="font-size:15px;font-weight:600; margin:20px;"
            >奖品名称： {{item.name}}</span>
            <el-form-item
              label="奖品名称"
              :prop="'gifts.' + index + '.name'"
              :rules="[
      { required: true, message: '奖品名称不能为空', trigger: 'blur' },
    ]"
            >
              <el-input v-model="item.name" placeholder="请输入奖品名称" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item
              label="数量"
              :prop="'gifts.' + index + '.count'"
              :rules="[
      { required: true, message: '数量不能为空', trigger: 'blur' },
      { type: 'number', message: '数量必须为数字值' },
          { pattern: /^[1-9]+[0-9]*$|^0$/, message: '非负整数（正整数 + 0）',trigger: 'blur'}
    ]"
            >
              <el-input v-model.number="item.count" placeholder="请输入数量" :clearable="true"></el-input>
            </el-form-item>
            <el-collapse accordion>
              <el-collapse-item>
                <span
                  style="font-size:14px;font-weight:600; margin:20px;padding-left:110px"
                  slot="title"
                >
                  奖品信息
                  <i class="header-icon el-icon-info" style="margin-left: 10px;"></i>
                </span>
                <el-form-item
                  label="奖品Icon"
                  :prop="'gifts.' + index + '.icons'"
                  :rules="[
      { required: true, message: '请上传奖品Icon', trigger: 'blur' },
    ]"
                >
                  <uploadImg
                    v-model="item.icons"
                    :imgSize="1"
                    :text="['图片大小500kb以内', '图片格式png/jpg/gif','图片宽度48px,高度39px']"
                  ></uploadImg>
                </el-form-item>
                <el-form-item
                  label="默认图标"
                  :prop="'gifts.' + index + '.defaultIcon2'"
                  :rules="[
      { required: true, message: '请上传默认图标', trigger: 'blur' },
    ]"
                >
                  <uploadImg
                    v-model="item.defaultIcon2"
                    :imgSize="1"
                    :text="['图片大小500kb以内', '图片格式png/jpg/gif','图片宽度48px,高度39px']"
                  ></uploadImg>
                </el-form-item>
                <el-form-item label="获奖范围 如(1~10)">
                  <!-- <el-input v-model.number="item.rankLimitEnd" placeholder="请输入获奖范围" :clearable="true"></el-input> -->
                  <el-input-number v-model="item.rankLimitStart" :min="1" :max="10000" label="最高报名"></el-input-number>&nbsp;&nbsp; ~ &nbsp;&nbsp;
                  <el-input-number v-model="item.rankLimitEnd" :min="1" :max="10000" label="最底报名"></el-input-number>
                </el-form-item>

                <el-form-item label="类型">
                  <prizeType
                    @skuType="skuTypes"
                    @getselect="getselects"
                    :prizeindex="index"
                    :type="item.type"
                    :prizeval="item.value"
                  ></prizeType>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
            <div style="display: flex;justify-content: center;margin-top: 14px;">
              <!-- <el-button type="primary" size="mini" @click="addList">+增加奖品</el-button> -->
              <el-button
                type="danger"
                size="mini"
                @click="removeList(index)"
                v-if="index !== 0"
              >-删除奖品</el-button>
            </div>
          </el-collapse-item>
          <div style="display: flex;justify-content: center;margin-bottom: 14px;margin-top: 14px;">
            <el-button type="primary" size="mini" @click="addList">+增加奖品</el-button>
            <!-- <el-button
                type="danger"
                size="mini"
                @click="removeList(index)"
                v-if="index !== 0"
            >-删除奖品</el-button>-->
          </div>
        </el-collapse>
      </div>
      <div class="footer" v-if="judge">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="getCreate('form')">确 定(新增)</el-button>
      </div>
      <div class="footer" v-else>
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="getModify('form')">确 定(编辑)</el-button>
      </div>
    </el-form>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import uploadImg from '@/components/uploadImage/index.vue'
import uploadImg3 from '@/components/uploadImage/index.vue'
import uploadVideo from '@/components/uploadVideo/index.vue'
import { certList } from '@/api/demo/close/index'
import { getThemeList } from '@/api/demo/punchInActivity/index'
import {
  addContest,
  megagameInfo,
  megagameUpdate
} from '@/api/demo/competition/index'
import jumpType from '@/components/jumpType/jumpType.vue'
import prizeType from '@/components/prizeType/index.vue'
import moment from 'moment'
export default {
  name: 'addContestManger',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    uploadImg,
    uploadVideo,
    jumpType,
    uploadImg3,
    prizeType
  },
  data () {
    return {
      form: {
        title: '', // 标题
        subTitle: '', // 副标题
        titleImg: '', // 标题图片
        titleImg2: [], // 标题图片
        cover2: [], // 封面图
        cover: '', // 封面图
        certIds: [], // 限制证书
        clockInThemeIds: [], // 关联任务
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        lotteryTime: '', // 开奖时间
        // isLottery:0,//0 未开奖 1 已开奖
        giftBg: '', // 奖品背景,
        giftBg2: [],
        guideVideo: '', // 主题视频
        guideVideo2: [], // 主题视频
        contentBg: '', // 内容图片
        contentBg2: [],
        taskBg: '', // 任务背景
        taskBg2: [], // 任务背景
        themeBg: '', // 主题背景
        themeBg2: [], // 主题背景
        ruleInfo: '', // 规则详情
        ruleInfo2: [], // 规则详情
        // status:0,
        lotteryType: 0, // 开奖方式
        joinType: 0, // 参与方式
        joinWaysList: [
          {
            icon: '', // 图标
            paramsType: '', // 参数类型
            skipType: '', // 跳转类型
            url: '', // 跳转地址
            value: '', // 参数值
            Jumpurl: {
              url: null,
              id: null,
              classId: null,
              paramType: '0',
              value: ''
            }
          }
        ], // 参与途径
        gifts: [
          {
            count: 0, // 数量
            defaultIcon: '', // 默认图标
            defaultIcon2: [],
            icon: '', // 奖品图标
            icons: [], // 奖品图标
            id: '', // 奖品id
            name: '', // 奖品名称
            rankLimit: '', // 排名限制 最低排名
            type: 0, // 0 无奖品 1 实体物品 2 克拉数 3 优惠券 4 经验值 5 抽奖机会 6 勋章
            value: '', // 虚拟物品值
            value2: '',
            getCardList: [] // 卡片集合
          }
        ] // 奖品集合
      },
      listQuery: {
        currentPage: 1,
        pageSize: 1000
      },
      getId: '',
      certIdList: [], // 证书集合
      themeData: [], // 任务集合
      judge: true,
      rules: {
        name: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur'
          }
        ],
        subTitle: [
          {
            required: true,
            message: '请输入副标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur'
          }
        ],
        certIds: [
          { required: true, message: '请选择限制参与证书', trigger: 'blur' }
        ],
        titleImg2: [
          { required: true, message: '请上传标题图片', trigger: 'blur' }
        ],
        cover2: [{ required: true, message: '请上传封面图', trigger: 'blur' }],
        startTime: [
          { required: true, message: '请选择日期时间', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '请选择日期时间', trigger: 'blur' }
        ],
        lotteryTime: [
          { required: true, message: '请选择日期时间', trigger: 'blur' }
        ],
        giftBg2: [
          { required: true, message: '请选择奖品背景', trigger: 'blur' }
        ],
        limitGrowth: [
          { required: true, message: '经验值门槛不能为空' },
          { type: 'number', message: '经验值门槛必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ],
        guideVideo2: [
          { required: true, message: '请上传主题视频', trigger: 'blur' }
        ],
        contentBg2: [
          { required: true, message: '请上传内容背景', trigger: 'blur' }
        ],
        taskBg2: [
          { required: true, message: '请上传任务背景', trigger: 'blur' }
        ],
        themeBg2: [
          { required: true, message: '请上传主题背景', trigger: 'blur' }
        ],
        clockInThemeIds: [
          { required: true, message: '请选择任务', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {},
  created () {
    let that = this
    that.getId = this.$route.query.id
    that.getSearch()
    that.getList()
    console.log('that.getId', that.getId)
    if (that.getId == null) {
      that.judge = true
    } else {
      that.judge = false
      megagameInfo(that.getId).then(res => {
        // that.form = res;
        // console.log("res.joinWaysList", res.joinWaysList);
        if (res.joinWaysList == null) {
          res.joinWaysList = [
            {
              icon: '', // 图标
              paramsType: '', // 参数类型
              skipType: '', // 跳转类型
              url: '', // 跳转地址
              value: '', // 参数值
              Jumpurl: {
                url: null,
                id: null,
                classId: null,
                paramType: '0',
                value: ''
              }
            }
          ]
        } else {
          res.joinWaysList.map(item => {
            item.icon = item.icon
            item.paramsType = item.paramsType
            if (parseInt(item.paramsType) == 1) {
              item.value = parseInt(item.value)
            }
            item.value = item.value
            item.url = item.url
            item.skipType = item.skipType
            item.Jumpurl = {
              url: item.url,
              id: parseInt(item.skipType),
              classId: null,
              paramType: item.paramsType,
              value: item.value
            }
          })
        }
        that.form = res
      })
    }
  },
  mounted () {},
  methods: {
    // 证书集合
    getSearch () {
      let that = this
      certList(that.listQuery).then(res => {
        that.listLoading = true
        that.certIdList = res.records
        that.listLoading = false
      })
    },
    // 活动列表
    getList () {
      let that = this
      getThemeList(this.listQuery).then(res => {
        that.listLoading = true
        that.themeData = res.records
        that.listLoading = false
      })
    },
    // 新增
    getCreate (forms) {
      let that = this
      const set = this.$refs
      set[forms].validate(valid => {
        if (valid) {
          that.form.startTime = moment(that.form.startTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          that.form.endTime = moment(that.form.endTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          that.form.lotteryTime = moment(that.form.lotteryTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )

          that.form.joinWaysList.map(item => {
            (item.icon = item.icon),
            (item.paramsType = item.Jumpurl.paramType),
            (item.value = item.Jumpurl.value),
            (item.skipType = item.Jumpurl.id),
            (item.url = item.Jumpurl.url)
          })
          addContest(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push({
              path: '/demo/competition'
            })
          })
          console.log('form', that.form)
        } else {
          return false
        }
      })
    },
    // 修改
    getModify (forms) {
      let that = this
      const set = this.$refs
      set[forms].validate(valid => {
        if (valid) {
          that.form.startTime = moment(that.form.startTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          that.form.endTime = moment(that.form.endTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          that.form.lotteryTime = moment(that.form.lotteryTime).format(
            'YYYY-MM-DD HH:mm:ss'
          )

          that.form.joinWaysList.map(item => {
            (item.icon = item.icon),
            (item.paramsType = item.Jumpurl.paramType),
            (item.value = item.Jumpurl.value),
            (item.skipType = item.Jumpurl.id),
            (item.url = item.Jumpurl.url)
          })
          megagameUpdate(that.getId, that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push({
              path: '/demo/competition'
            })
          })
        }
      })
    },
    // 取消
    cancel (formName) {
      this.$router.push('/demo/competition')
    },
    // 类型
    skuTypes (val1, val2) {
      let that = this
      for (let index = 0; index < that.form.gifts.length; index++) {
        if (index == val2) {
          that.form.gifts[index].type = val1
        }
      }
      // console.log("val", val1, val2);
    },
    getselects (val1, val2) {
      let that = this
      for (let index = 0; index < that.form.gifts.length; index++) {
        if (index == val2) {
          that.form.gifts[index].value = val1
        }
      }
      // console.log('that.form.gifts',that.form.gifts)
    },
    // 新增奖品集合
    addList () {
      this.form.gifts.push({
        count: 0, // 数量
        defaultIcon: '', // 默认图标
        defaultIcon2: [],
        icon: '', // 奖品图标
        icons: [], // 奖品图标
        id: '', // 奖品id
        name: '', // 奖品名称
        rankLimit: '', // 排名限制 最低排名
        type: 0, // 0 无奖品 1 实体物品 2 克拉数 3 优惠券 4 经验值 5 抽奖机会 6 勋章
        value: '', // 虚拟物品值
        value2: '',
        getCardList: [] // 卡片集合
      })
    },
    // 删除奖品集合
    removeList (index) {
      this.form.gifts.splice(index, 1)
      this.form.gifts.forEach((item, index) => {
        item.index = index
      })
    },
    // 新增跳转模块
    addjumpModal (index3) {
      this.form.joinWaysList.push({
        icon: '',
        Jumpurl: {
          url: null,
          id: null,
          classId: null,
          paramType: '0',
          value: ''
        },
        paramType: 0,
        value: '', // 参数值
        url: '', // 跳转地址
        skipType: '' // 跳转类型
      })
    },
    // 删除跳转模块
    removejumpModal (index3) {
      this.form.joinWaysList.splice(index3, 1)
    }
  }
}
</script>

<style scoped>
.footer {
  text-align: center;
  margin-top: 20px;
}
</style>
